import { useEffect, useState } from "react";
import { Score } from "../Components/Home/Score";
import { Tickets } from "../Components/Home/Tickets"
import { Loading } from "../Components/Loading/Loading";
import { redirectToLogin } from "../utils/auth";
import { useUser } from "../context/UserContext";

export const Home = () => {
  const [tickets, setTickets] = useState([]);
  const [dataLoading, setDataLoading] = useState(true);
  const [activeIndex, setActiveIndex] = useState("total");
  const [priorities, setPriorities] = useState([]);
  const [requestOptions, setRequestOptions] = useState([]);
  const [status, setStatus] = useState([]);
  const [count, setCount] = useState({});

  const { user } = useUser();
  const { username } = user;

  const authToken = localStorage.getItem("authToken");

  useEffect(() => {
    if (!authToken) {
      redirectToLogin();
      return;
    }

    const BASE = process.env.REACT_APP_BACKEND_URL;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    };

    const get = (url) =>
      fetch(url, { method: "GET", headers }).then((r) => {
        if (r.status === 401) {
          redirectToLogin();
          return null;
        }
        return r.json();
      });

    Promise.all([
      get(`${BASE}/API/V2/Tickets`),              // tickets
      get(`${BASE}/API/V2/config/priorities`),     // priorities
      get(`${BASE}/API/V2/config/requesttypes`),   // requestOptions
      get(`${BASE}/API/V2/config/status`),         // status
    ])
      .then(([ticketsData, prioritiesData, requestTypesData, statusData]) => {
        if (!ticketsData || !prioritiesData || !requestTypesData || !statusData) return;

        if (ticketsData.error) {
          if (ticketsData.error === "Invalid Organisation ID") {
            alert("Invalid Organisation ID");
            redirectToLogin();
          } else {
            alert("Internal Server Error");
          }
          return;
        }

        setTickets(ticketsData);
        setPriorities(prioritiesData);
        setRequestOptions(requestTypesData);
        setStatus(statusData);
        setDataLoading(false);
      })
      .catch((err) => console.log(err));
  }, []);

  if (dataLoading || !user.loaded) {
    return <Loading />;
  }

  return (
    <div className="max-w-[1240px] mx-auto w-full px-7 pt-7 pb-14 flex flex-col gap-8">
      <Score
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
        count={count}
        status={status}
      />

      <Tickets
        tickets={tickets}
        setCount={setCount}
        requestOptions={requestOptions}
        priorities={priorities}
        status={status}
        activeIndex={activeIndex}
        username={username}
      />
    </div>
  );
};
